import { render, staticRenderFns } from "./InventoryQuery.vue?vue&type=template&id=5853cb0b&scoped=true"
import script from "./InventoryQuery.vue?vue&type=script&lang=js"
export * from "./InventoryQuery.vue?vue&type=script&lang=js"
import style0 from "./InventoryQuery.vue?vue&type=style&index=0&id=5853cb0b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5853cb0b",
  null
  
)

export default component.exports